import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider, createBrowserRouter } from 'react-router';
import { useTelegramViewport } from '@/telegram';
import { AuthGate } from '@/features/auth/AuthGate';
import { RuntimeDebugOverlay } from '@/shared/components/ui/RuntimeDebugOverlay';
import { useRuntimeDiagnostics } from '@/runtime/useRuntimeDiagnostics';
import { routes } from './routes';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 2,
      staleTime: 1000 * 60,
    },
  },
});

const router = createBrowserRouter(routes);

function AppInner() {
  useTelegramViewport();
  const { snapshot, debugEnabled } = useRuntimeDiagnostics();

  return (
    <AuthGate>
      <RouterProvider router={router} />
      <RuntimeDebugOverlay
        debugEnabled={debugEnabled}
        snapshot={snapshot}
        pathname={window.location.pathname}
      />
    </AuthGate>
  );
}

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AppInner />
    </QueryClientProvider>
  );
}
